var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5772",
    "data-name": "Group 5772",
    transform: "translate(-1075 -641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    transform: "translate(1107 641) rotate(90)",
    fill: "#fff",
    stroke: "#0923e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right",
    d: "M15.532,5.8l-5.078,5.078a.423.423,0,0,1-.6-.6l4.355-4.355H.423a.423.423,0,1,1,0-.846H14.211L9.856.722a.423.423,0,0,1,.6-.6L15.533,5.2a.423.423,0,0,1,0,.6Z",
    transform: "translate(1096.5 649) rotate(90)",
    fill: "#0923e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewDown);
export default __webpack_public_path__ + "static/media/preview_down.7525cdbbf479a5463d321a16a77be62a.svg";
export { ForwardRef as ReactComponent };